import $ from 'jquery';
import 'jquery.cookie';

export { $ };
window.$ = $;
window.jQuery = $;

import * as bannersInner from '@banners';

import { exportGetScript, getScript } from '../../../src/js/common/utils/fn';

window.fn = window.fn ?? {};
window.fn.banners = bannersInner;
window.getScript = exportGetScript;

Object.assign(window.fn, {
  getScript,
});

import '../consent/msnt-consent';

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

window.fn.banners.banners();

// msntConsent.initShareBlock($('.postBody'));
